import { render } from "./Additional-product.vue?vue&type=template&id=d260b052&scoped=true"
import script from "./Additional-product.vue?vue&type=script&lang=js"
export * from "./Additional-product.vue?vue&type=script&lang=js"

import "./Additional-product.vue?vue&type=style&index=0&id=d260b052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d260b052"]])

export default __exports__